import { useMemo } from "react";

// Count property occurrences in data
export function CountItems(data, propertyName) {
  return useMemo(() => {
    if (!data || !propertyName) return [];

    const tally = {};
    data.forEach(f => {
      const prop = f.properties?.[propertyName];
      if (prop) tally[prop] = (tally[prop] || 0) + 1;
    });

    return Object.entries(tally).map(([name, value]) => ({ name, count: value }));
  }, [data, propertyName]);
}

// Sort items by a key (default "value")
export function SortItems(data, key) {
  return useMemo(() => {
    if (!Array.isArray(data)) return [];
    return [...data].sort((a, b) => b[key] - a[key]);
  }, [data, key]);
}

// Get top N items, group rest as "Others"
export function GetTopItems(data, topN = 3, label) {
  return useMemo(() => {
    if (!Array.isArray(data)) return [];

    if (data.length <= topN) return data;

    const top = data.slice(0, topN);
    const othersCount = data
      .slice(topN)
      .reduce((sum, item) => sum + (item.count || item.value || 0), 0);

    if (othersCount > 0) {
      top.push({ name: label, count: othersCount });
    }

    return top;
  }, [data, topN, label]);
}

// Count total of all values
export function CountTotal(data, key) {
  return useMemo(() => {
    if (!Array.isArray(data)) return 0;
    return data.reduce((sum, item) => sum + (item[key] || 0), 0);
  }, [data, key]);
}
